import { render, staticRenderFns } from "./store-management.vue?vue&type=template&id=5278aa9b&scoped=true"
import script from "./store-management.vue?vue&type=script&lang=js"
export * from "./store-management.vue?vue&type=script&lang=js"
import style0 from "./store-management.vue?vue&type=style&index=0&id=5278aa9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278aa9b",
  null
  
)

export default component.exports